/**
 * Utility functions for handling photo URLs
 * Ensures photo URLs are properly formatted with API base URL
 */

import { API_BASE } from '../config/api';

/**
 * Normalize a photo URL to ensure it's a full URL
 * Handles both relative paths (starting with /) and full URLs
 */
export const normalizePhotoUrl = (url: string | undefined | null): string | null => {
  if (!url || url.trim() === '') {
    return null;
  }

  const trimmedUrl = url.trim();

  // If it's already a full URL (http/https), return as is
  if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
    return trimmedUrl;
  }

  // If it's a relative path starting with /, prepend API_BASE
  if (trimmedUrl.startsWith('/')) {
    return `${API_BASE}${trimmedUrl}`;
  }

  // If it's a relative path without /, add / and prepend API_BASE
  return `${API_BASE}/${trimmedUrl}`;
};

/**
 * Get photo URL with fallback to thumbnail
 */
export const getPhotoUrl = (photo: { url?: string; thumbnailUrl?: string }): string | null => {
  const mainUrl = normalizePhotoUrl(photo.url);
  if (mainUrl) return mainUrl;

  const thumbUrl = normalizePhotoUrl(photo.thumbnailUrl);
  if (thumbUrl) return thumbUrl;

  return null;
};


